import lodash from 'lodash';

/**
 * React Select Custom Styling
 */
export const customStyles = {
    menu: (provided) => ({
        ...provided,
        color: 'black'
    }),
    singleValue: (provided, state) => {
        const color = 'black';
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, color, opacity, transition };
    },
    placeholder: (provided, state) => {
        const color = state.isDisabled ? '#0056ad' : 'black';
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return {
            ...provided,
            color, opacity, transition

        };
    },
    control: (provided) => ({
        ...provided,
        backgroundColor: '#f4f5f7'
    }),
    option: (provided) => ({
        ...provided,
        'color': '#0056b3',
        'font-family': 'Hind',
        'font-size': '1.143rem',
        'font-stretch': 'normal',
        'font-style': 'normal',
        'letter-spacing': 'normal',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#0056ad',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    })
};

export const customStylesV2 = {
    input: (provided) => ({
        ...provided,
        padding: 0
    }),
    menu: (provided) => ({
        ...provided,
        color: '#404040',
        'font-weight': 400,
    }),
    singleValue: (provided, state) => {
        const color = '#28282E';
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return {
            ...provided, color, opacity, transition, padding: 0,
            fontWeight: '400',
            fontStyle: 'normal',
            fontFamily: 'Hind',
            'line-height': '20px',
            'font-weight': 400
        };
    },
    placeholder: (provided, state) => {
        const color = state.isDisabled ? '#0056ad' : '#28282E';
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return {
            ...provided,
            color, opacity, transition,
            'font-weight': 'normal'
        };
    },
    control: (provided) => ({
        ...provided,
        'line-height': '20px',
        padding: '3px 2px',
        color: '#28282E',
        'min-height': '40px',
        boxShadow: 'unset',
        '&:focus, &:hover': {
            color: '#28282E',
            boxShadow: 'unset',
            borderColor: '#2057AD'
        },
    }),
    option: (provided) => ({
        ...provided,
        fontFamily: 'Hind',
        fontSize: '16px',
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        lineHeight: '20px',
        fontWeight: 400,

    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#0056ad',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    })
};

export const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
};

export const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.17em 0.5em',
    textAlign: 'center',
};


export function formatGroupLabel(data) {
    return (
        <div style={groupStyles}>
            <span>{data.label}</span>
            <span style={groupBadgeStyles}>{data.options.length}</span>
        </div>
    );
}

export function renderOptions(priorityOptions = [], allOptions) {
    const potentialMatches = priorityOptions.map(option => option.item);
    return [
        { label: 'Potential Matches', options: potentialMatches },
        { label: 'All Options', options: allOptions },
    ];
}

export const SELECT_STYLES = lodash.merge({}, customStyles, {
    control: (provided) => ({
        ...provided,
        backgroundColor: 'transparent',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'rgba(91, 91, 93, 1.0)',
    }),
});
